export enum SaalArt {
    Sitzplaetze = 'Sitzplaetze',
    Stehplaetze = 'Stehplaetze',
    Gemischt = 'Gemischt'
}